/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateEffect } from 'react-use';
// import { useMount, useUpdateEffect } from 'react-use';
import {
  BOT_STATUS_HEADER_DATA,
  BOT_STATUS_VIEW_LIST_LENGTHS,
  MODAL_TYPE_BOT_HIDE,
  MODAL_TYPE_BOT_HIDE_OFF,
  MODAL_TYPE_BOT_INSTALL,
  MODAL_TYPE_BOT_UNINSTALL,
} from '../common/consts';
import { getUserPId } from '../common/util';
import BotModal from '../components/bot/BotModal';
import BotTable from '../components/bot/BotTable';
import Toast from '../components/Toast';
import { getBotList, openModal, closeModal, setBot } from '../modules/bot';

const BotStatusContainer = () => {
  const dispatch = useDispatch();
  const { loading, list, contentItems, total, modal, update, listError } =
    useSelector((state) => state.bot);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    BOT_STATUS_VIEW_LIST_LENGTHS[0].value,
  );
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('title');
  const [selected, setSelected] = useState([]);
  const [snack, setSnack] = useState({ open: false });

  const handleModalCancel = () => {
    dispatch(closeModal());
    setSelected([]);
  };

  const handleModalConfirm = (args) => {
    if (
      modal.type === MODAL_TYPE_BOT_INSTALL ||
      modal.type === MODAL_TYPE_BOT_UNINSTALL
    ) {
      dispatch(
        setBot({ ...args, install: modal.type === MODAL_TYPE_BOT_INSTALL }),
      );
    } else if (
      modal.type === MODAL_TYPE_BOT_HIDE ||
      modal.type === MODAL_TYPE_BOT_HIDE_OFF
    ) {
      dispatch(
        setBot({ ...args, use: modal.type === MODAL_TYPE_BOT_HIDE_OFF }),
      );
    }
  };

  const onModalClick = (type, item) => {
    let items = item;
    if (!items) {
      items = selected.map((id) => list.find((li) => li.id === id));
    }
    dispatch(
      openModal({
        userId: getUserPId(),
        items,
        type,
      }),
    );
  };

  const handleSortClick = (property) => () => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleCheckClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);

    const { type, name } = event.target;
    if (type === 'button' && name) {
      onModalClick(name, [list.find((li) => li.id === id)]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const limit = rowsPerPage;
    const skip = page * limit;
    dispatch(
      getBotList({ sort: orderBy, desc: order === 'desc', skip, limit }),
    );
  }, [page, rowsPerPage, order, orderBy]);

  useUpdateEffect(() => {
    if (update.result !== null) {
      handleModalCancel();
      const messages = update.message;
      const message = update.error;
      const severity = update.result ? 'success' : 'error';
      setSnack({
        open: true,
        onClose: () => setSnack({ open: false }),
        messages,
        message,
        severity,
      });
    }
  }, [update.result]);

  return (
    <>
      <BotTable
        {...{
          title: '봇 목록',
          loading,
          contentItems,
          selectEnabled: selected.length > 0,
          onItemInstallClick: () => onModalClick(MODAL_TYPE_BOT_INSTALL),
          onItemHideClick: () => onModalClick(MODAL_TYPE_BOT_HIDE),
          onItemHideOffClick: () => onModalClick(MODAL_TYPE_BOT_HIDE_OFF),
          onItemUninstallClick: () => onModalClick(MODAL_TYPE_BOT_UNINSTALL),
          name: 'bot_status',
          headerItems: BOT_STATUS_HEADER_DATA,
          lengthOptions: BOT_STATUS_VIEW_LIST_LENGTHS,
          total,
          list,
          order,
          orderBy,
          rowsPerPage,
          page,
          selected,
          handleAllClick,
          handleCheckClick,
          handleChangePage,
          handleChangeRowsPerPage,
          handleSortClick,
          error: listError,
        }}
      />
      <BotModal
        {...{
          ...modal,
          onConfirm: handleModalConfirm,
          onCancel: handleModalCancel,
        }}
      />
      <Toast {...{ ...snack }} />
    </>
  );
};

export default BotStatusContainer;
